<template>
  <span v-if="isLoading" class="loader"></span>
</template>

<script lang="js" src="./LoaderDots"></script>
<style lang="scss" src="./LoaderDots.scss" scoped></style>
